import React from "react";
import { IconButton, InputAdornment, TextField } from "@mui/material";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";

function CustomInput({ onChange, value, name, onClear, ...rest }) {
  return (
    <TextField
      fullWidth
      size="small"
      variant="outlined"
      name={name}
      value={value}
      onChange={onChange}
      {...rest}
      InputProps={{
        endAdornment: (
          <InputAdornment position="end">
            <IconButton onClick={onClear} size="small">
              <HighlightOffIcon />
            </IconButton>
          </InputAdornment>
        ),
      }}
    />
  );
}

export default CustomInput;
